import ComparePointClouds from "./ComparePointClouds";

export default ComparePointClouds;